<template>
  <v-app-bar app height="64" elevation="4" color="#1A1A1a" class="app-bar">
    <div class="d-flex" style="width: 100%">
      <niko-icon style="height: auto" />
      <v-spacer />
      <div
        v-if="
          $route.fullPath === '/' ||
          $route.fullPath === '/project-unavailable' ||
          $route.fullPath === '/maintenance'
        "
      >
        <span class="body1">{{ getUserName() }}</span>
        <niko-container-dropdown
          :items="dropdownItems"
          @clicked="onDropdownItemClick($event)"
          width="212px"
          height="152px"
        />
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NikoIcon from "./icons/NikoIcon";
import NikoContainerDropdown from "./UI/NikoContainerDropdown";
import router from "../router";

export default {
  name: "toolbar",
  components: { NikoIcon, NikoContainerDropdown },
  computed: {
    ...mapState("authStore", [
      "email",
      "firstname",
      "lastname",
      "fullName",
      "fastspringAccountId",
      "activeSubscription",
      "accountManagementURL",
    ]),
    ...mapState("projectStore", ["maintenance"]),
    dropdownItems() {
      if (this.activeSubscription) {
        return [this.$i18n.t("premium.manage"), this.$i18n.t("logout")];
      }
      return [
        this.$i18n.t("logout"),
        { value: this.$i18n.t("premium.upgrade"), button: true },
      ];
    },
  },
  methods: {
    ...mapActions("authStore", [
      "getUserDetails",
      "logout",
      "checkPremiumStatus",
    ]),
    startLogout() {
      this.logout();
    },
    getUserName() {
      return this.fullName ? this.fullName : this.email;
    },
    openFastSpringPopup() {
      window.fastspring.builder.recognize({
        email: this.email,
        firstName: this.firstname,
        lastName: this.lastname,
      });
      window.fastspring.builder.add("fa-assistent-premium");
      window.fastspring.builder.checkout();
    },
    onDropdownItemClick(item) {
      if (item.value === this.$i18n.t("premium.upgrade")) {
        this.openFastSpringPopup();
      } else if (item.value === this.$i18n.t("premium.manage")) {
        window.open(this.accountManagementURL, "_blank").focus();
      } else {
        this.startLogout();
      }
    },
  },
  async created() {
    if (
      this.$route.fullPath === "/" ||
      this.$route.fullPath === "/maintenance"
    ) {
      await this.getUserDetails();
      this.fastspringAccountId && this.checkPremiumStatus();
      window.fastspring.builder.recognize({
        email: this.email,
        firstName: this.firstname,
        lastName: this.lastname,
      });
    }
  },
  watch: {
    maintenance() {
      if (this.maintenance) {
        router.push("/maintenance");
      } else if (!this.maintenance) {
        router.push("/");
        this.getUserDetails();
      }
    },
  },
};
</script>

<style lang="scss">
#nikoApp {
  .v-toolbar__content {
    padding-left: 24px !important;
    padding-right: 4px !important;
  }
  .app-bar {
    box-shadow: none !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
  }
}
</style>
